<ng-container *ngIf="state === 'loading'">
  <div class="loading">
    <app-spinner></app-spinner>
    <h1>Just a moment...</h1>
  </div>
</ng-container>

<ng-container *ngIf="pixelImpression">
  <img style="opacity: 0; pointer-events: none;" [src]="pixelUrl" width="1" height="1" />
</ng-container>

<div *ngIf="state === 'ready'" class="confirmed-container" [class.is-framed]="isFramed">
    <div class="profile-container">
      <div><img src="/assets/offers/profile-picture.png"></div>
      <div class="new-user">
        <div class="name" *ngIf="user">{{user.display_name}}</div>
        <div class="type" *ngIf="plusMember">Plus Member</div>
      </div>
    </div>
    <div class="thank-you" [innerHTML]="thankYouMessage | trustHtml"></div>
    <div class="enjoy" [innerHTML]="enjoyLegend | trustHtml"></div>

    <div class="contribution-grant" *ngIf="contributionGrant > 0">
      Your contribution grants you access to <strong>TYT membership content</strong> for 
      <strong>{{contributionGrant}} {{unitLabel(contributionGrant, 'month', 'months')}}!</strong>
      
      You can now watch premium content on TYT.com or via any of our mobile/TV apps.
    </div>

    <div class="shout-out" *ngIf="purchaseType && purchaseUUID">
      Would you like an <strong>on-air shout out</strong> for {{ purchaseType === 'Membership' ? 'becoming a TYT member' : 'making this one-time contribution' }}?

      <mat-radio-group name="shoutOutPref" [(ngModel)]="shoutOutPref">
        <mat-radio-button value="yes">Heck yeah!</mat-radio-button>
        <mat-radio-button value="no">No, I'd prefer not to get a shout-out on-air</mat-radio-button>
      </mat-radio-group> 

      If you join when we're not live on air, we'll do our best to catch up with shout-outs when we're back. 
      Make sure to <a href="{{ liveScheduleUrl }}" target="_blank">watch us live</a>!
    </div>

    <button mat-raised-button class="go-button" [class.save]="shoutOutPref" (click)="saveAndProceed()">{{ displayedGoText }}<img src="/assets/offers/arrow-right.svg"></button>
    <ng-container *ngIf="!isFramed">
      <div class="logo" *ngIf="!isFramed"><img src="/assets/offers/tyt_logo.png"></div>
    </ng-container>
</div>

<tyt-staging-note class="pixel-debugger" *ngIf="enablePixelDebugger">
  <div class="property">
    Pixel: {{pixelImpression ? 'Sent' : 'Not Sent'}} [{{pixelEndpoint}}]
  </div>
</tyt-staging-note>

<div id="offer-snippet" #offerSnippet></div>